import { Component, EventEmitter, forwardRef, Inject, OnInit, Output } from '@angular/core';
import { BaseWidget, NgAisInstantSearch } from 'angular-instantsearch';
import { connectSortBySelector } from 'instantsearch.js/es/connectors';
import { SortModel } from '@app/shared/model/interfaces/catalog';
import { RefinementsService } from '@app/shared/components/catalog/services/refinements.service';
import { SearchIndex } from '@app/shared/components/catalog/services/instantsearch.service';
import { LocaleService } from '@app/core/i18n';
import { KeyboardService } from '@app/shared/services/keyboard/keyboard.service';

@Component({
  selector: 'vc-custom-sort-by-selector',
  templateUrl: './custom-sort-by-selector.component.html',
  styleUrls: ['./custom-sort-by-selector.component.scss']
})
export class CustomSortBySelectorComponent extends BaseWidget implements OnInit {
  // tslint:disable-next-line
  @Output('update')
  change: EventEmitter<number> = new EventEmitter();

  public indices: SortModel[] = [
    {
      name: SearchIndex.Default,
      label: 'Relevance'
    },
    {
      name: SearchIndex.PriceAsc,
      label: 'Price: Low to High'
    },
    {
      name: SearchIndex.PriceDesc,
      label: 'Price: High to Low'
    },
    {
      name: SearchIndex.Recent,
      label: 'Most recent'
    }
  ];

  public state: {
    currentRefinement: string;
    options: { value: string; label: string }[];
    refine: (string) => void;
    hasNoResults: boolean;
    widgetParams: any;
  };
  constructor(
    @Inject(forwardRef(() => NgAisInstantSearch)) public instantSearchParent: NgAisInstantSearch,
    private localeService: LocaleService,
    private refinementsService: RefinementsService,
    public keyboardNavigation: KeyboardService
  ) {
    super('CustomSortBySelectorComponent');
    switch (this.localeService.getCountry()) {
      case 'US':
        this.indices[0].name = SearchIndex.DefaultUs;
        break;
    }
  }

  ngOnInit() {
    this.createWidget(connectSortBySelector, {
      indices: this.indices
    });
    super.ngOnInit();
  }

  updateSelected(sortModel: SortModel) {
    const index = this.indices.findIndex(model => sortModel.name === model.name);
    this.refinementsService.setSortByValue({ name: sortModel.name, index });
    this.state.refine(sortModel.name);
    this.change.emit(index);
  }

  // check what key triggers the event, only space and enter keys can activate method
  checkActivationButtonKeyService(event, item) {
    if (this.keyboardNavigation.checkActivationButtonKey(event)) {
      this.updateSelected(item);
    }
  }

  // Reset the selected sort
  // Defaults to 0
  resetSelected() {
    this.updateSelected(this.indices[0]);
  }
}
